import { ClientTitular } from "../../hooks/ClientProvider";
import { ClientData } from "./types";

type ClientDependent = Pick<ClientTitular, "id" | "cpf"> & {
  nome: string;
  idClienteTitularAssociado?: number;
  nomeSocial?: string;
};

export function formatClientTitular({
  clientCtx,
}: {
  clientCtx: { client: ClientTitular };
}): ClientData {
  return {
    id: clientCtx.client.id,
    name: clientCtx.client.name,
    type: "titular",
    cpf: clientCtx.client.cpf,
    nomeSocial: clientCtx?.client?.socialName,
  };
}

export function formatClientAndDependents({
  clientCtx,
  dependents,
}: {
  clientCtx?: { client: ClientTitular };
  dependents?: ClientDependent[];
}): ClientData[] {
  if ((!clientCtx && !dependents) || !clientCtx) {
    return [];
  }

  const formattedClient = formatClientTitular({ clientCtx });

  if (!dependents) {
    return [formattedClient];
  }

  const formattedDependents = dependents.map<ClientData>((person) => ({
    id: person.id,
    name: person.nome,
    type: "dependente",
    cpf: person.cpf,
    idTitular: person.idClienteTitularAssociado || formattedClient.id,
    nomeSocial: person?.nomeSocial,
  }));

  return [formattedClient, ...formattedDependents];
}
